module.exports = __webpack_public_path__ + "media/images/online/online-wedding-basic-plan-image-179aa089c5da0c312a12748bdf3eefe9.png";